export const viStates = [{ value: 'VI', label: 'VI' }]
